import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FlashMessageService } from './flash-message.service';

@Injectable()
export class ErrorHandlerService {

  constructor(
    private flashMessageService: FlashMessageService,
    private router: Router
  ) { }

  public handleError(error: any, message: string = ''): Promise<any> {
    switch (error.status) {
      case 500:
        message = 'Our Servers experienced a problem, please try again later';
        break;
      case 400:
        message = 'The input data is incorrect, please resubmit your form';
        break;
      case 404:
        message = 'This URL doesn\'t exist';
        break;
      case 401:
        message = 'You are unauthorized to view this screen';
        break;
      case 409:
        message = 'This user already exists';
        break;
    }
    this.flashMessageService.updateMessage(message, 3000);
    return Promise.reject(message || error);
  }

  public redirectBack(redirect, route) {
    this.router.navigate([redirect], { relativeTo: route });
    return false;
  }
}
